module.exports = __webpack_public_path__ + "static/media/preloader.b4d29153.gif";